import { Button, Form, Modal, Spinner } from "react-bootstrap";

const ConfirmBookingModal = ({
  show,
  onClose,
  onConfirm,
  booking,
  form,
  onChange,
  availableDrivers,
  isLoadingDrivers,
  isSubmitting,
}) => {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton={!isSubmitting}>
        <Modal.Title>Confirm Booking</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p className="mb-3 text-muted">
          Confirm pending booking for <strong>{booking?.customerSnapshot?.name || booking?.fullName || "customer"}</strong>
          .
        </p>

        <Form.Group className="mb-3">
          <Form.Label>Assign Driver</Form.Label>
          <Form.Select
            value={form.driverId}
            onChange={(e) => onChange("driverId", e.target.value)}
            disabled={isLoadingDrivers || isSubmitting}
          >
            <option value="">Select available driver</option>
            {availableDrivers.map((driver) => (
              <option key={driver?._id} value={driver?._id}>
                {driver?.name || "Unnamed Driver"} {driver?.contactNumber ? `(${driver.contactNumber})` : ""}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        <div className="row g-2">
          <div className="col-md-6">
            <Form.Group className="mb-2">
              <Form.Label>Half Day After Hours</Form.Label>
              <Form.Control
                type="number"
                min="0"
                value={form.overtimeRules.halfDayAfterHours}
                onChange={(e) => onChange("halfDayAfterHours", e.target.value, true)}
                disabled={isSubmitting}
              />
            </Form.Group>
          </div>
          <div className="col-md-6">
            <Form.Group className="mb-2">
              <Form.Label>Full Day After Hours</Form.Label>
              <Form.Control
                type="number"
                min="0"
                value={form.overtimeRules.fullDayAfterHours}
                onChange={(e) => onChange("fullDayAfterHours", e.target.value, true)}
                disabled={isSubmitting}
              />
            </Form.Group>
          </div>
          <div className="col-md-6">
            <Form.Group className="mb-2">
              <Form.Label>Half Day Charge</Form.Label>
              <Form.Control
                type="number"
                min="0"
                value={form.overtimeRules.halfDayCharge}
                onChange={(e) => onChange("halfDayCharge", e.target.value, true)}
                disabled={isSubmitting}
              />
            </Form.Group>
          </div>
          <div className="col-md-6">
            <Form.Group className="mb-2">
              <Form.Label>Full Day Charge</Form.Label>
              <Form.Control
                type="number"
                min="0"
                value={form.overtimeRules.fullDayCharge}
                onChange={(e) => onChange("fullDayCharge", e.target.value, true)}
                disabled={isSubmitting}
              />
            </Form.Group>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={onClose} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onConfirm} disabled={isSubmitting || !form.driverId}>
          {isSubmitting ? (
            <>
              <Spinner as="span" animation="border" size="sm" className="me-2" />
              Confirming...
            </>
          ) : (
            "Confirm Booking"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmBookingModal;
